// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3rEPU","range":"MonthRangeSwitch_range__YONKq","disabled":"MonthRangeSwitch_disabled__3ODFM"};